import { render, staticRenderFns } from "./SupplierProductList.vue?vue&type=template&id=2e35000c"
import script from "./SupplierProductList.vue?vue&type=script&lang=js"
export * from "./SupplierProductList.vue?vue&type=script&lang=js"
import style0 from "./SupplierProductList.vue?vue&type=style&index=0&id=2e35000c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports